import { LOCALES } from './locales';
import { SupportedLocaleType } from './SupportedLocale.type';

export const DEFAULT_LANGUAGE: SupportedLocaleType = LOCALES.RU;
